import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { userCardsQueryOptions } from "../api/queries"

registerNotification("card_like", {
	handle: ({ notification_id, data }, ctx) => {
		const { queryKey } = userCardsQueryOptions(ctx.userId)
		ctx.queryClient.setQueryData(queryKey, (old) =>
			old?.map((card) => {
				if (card.id !== data.card_id) return card
				return { ...card, count_likes: data.like_count }
			}),
		)
		ctx.queryClient.invalidateQueries({ queryKey, refetchType: "none" })

		showNotification({
			type: "card-like",
			placement: "home",
			cardId: data.card_id,
			likeCount: data.like_count,
			notificationId: notification_id,
			origin: "server",
			name: "card_like",
		})
	},
	route: ({ data }) => ({ to: "/profile", search: { card: data.card_id } }),
	routePopup: null,
})
